import { Step, StepLabel, Stepper } from '@tempmee/react';

interface IStepIndicatorProps {
  /** Ordered step labels. */
  steps: string[];
  /** 0-based index of the current step. */
  currentStep: number;
}

/**
 * Horizontal step indicator for multi-step flow headers, built on the DS `Stepper`.
 *
 * A thin props-based wrapper replacing the deprecated `@tempmee/react`
 * `StepperIndicator`: several flows render the same `steps` array + current index,
 * so the `Stepper`/`Step`/`StepLabel` composition lives here once.
 */
export const StepIndicator = ({ steps, currentStep }: IStepIndicatorProps) => (
  <Stepper activeStep={currentStep}>
    {steps.map((step) => (
      <Step key={step}>
        <StepLabel>{step}</StepLabel>
      </Step>
    ))}
  </Stepper>
);
